const CSS = [
  "<style>a,abbr,acronym,address,applet,article,aside,audio,b,big,blockquote,body,canvas,caption,center,cite,code,dd,del,details,dfn,div,dl,dt,em,embed,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,header,hgroup,html,i,iframe,img,ins,kbd,label,legend,li,mark,menu,nav,object,ol,output,p,pre,q,ruby,s,samp,section,small,span,strike,strong,sub,summary,sup,table,tbody,td,tfoot,th,thead,time,tr,tt,u,ul,var,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline}article,aside,details,figcaption,figure,footer,header,hgroup,menu,nav,section{display:block}body{line-height:1}ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:after,blockquote:before,q:after,q:before{content:'';content:none}table{border-collapse:collapse;border-spacing:0}</style>",
  `
  <style>
    @page {
      size: A4; /* DIN A4 standard, Europe */
      margin: 0;
    }
    html, body {
        width: 210mm;
        height: 297mm;
        font-size: 11px;
        overflow:visible;
        box-sizing: border-box;
    }
    body {
        padding-top: 9.6mm;
        padding-left: 4.2mm;
        padding-right: 4.2mm;
    }
    div {
        box-sizing: border-box;
    }
    .row::after {
        display: block;
        clear: both;
        content: "";
    }
    .row {
        position: relative;
        padding-left: .8mm;
        padding-right: .8mm;
    }
    .row-title {
        position: absolute;
        top: 0;
        left: 0;
        width: 201.6mm;
        height: 7.9mm;
    }
    .col {
        position: static;
        float: left;
        width: 50%;
        height: 52.4mm;
        margin-bottom: 3.6mm;
    }
    .col-inner {
        position: relative;
    }
    .card {
        position: absolute;
        top: 1.4mm;
        left: 2mm;
        width: 96mm;
        height: 51mm;
    }
    .card .title {
        padding-top: .5mm;
        width: 100%;
        height: 6.5mm;
        padding-left: 5mm;
        font: 300 4.4mm/5.2mm Roboto;
        text-transform: capitalize;
        color: #fff;
    }
    .card .title .icon {
        display: inline-block;
        width: 5.1mm;
        height: 5.1mm;
        padding: .7mm .5mm;
    }
    .card .content {
        position: static;
    }
    .card .content-inner {
        position: relative;
    }
    .card .content-left {
        position: absolute;
        left: 5mm;
        top: 3.6mm;
        width: 56.3mm;
    }
    .card .content-left .slogan {
        height: 18.7mm;
        overflow: hidden;
        font: 700 5.9mm/8mm "Open Sans";
        text-transform: capitalize;
        margin-bottom: 2.9mm;
    }
    .card .content-left .desc {
        height: 3.8mm;
        overflow: hidden;
        font: 300 3.6mm/4.2mm "Roboto";
        text-transform: capitalize;
        color: #424C51;
    }
    .card .content-left .desc + .desc {
        margin-top: 1mm;
    }
    .card .content-left .footer {
        margin-top: 2.9mm;
        font: italic 300 2.6mm/3.8mm "Roboto";
        color: #424C51;
    }
    .card .content-left .footer .logo {
        float: left;
        height: 2.8mm;
        margin-right: 1.1mm;
        margin-bottom: 1mm;
    }
    .card .content-right {
        position: absolute;
        right: 5mm;
        top: 3mm;
        width: 27.3mm;
    }
    .card .content-right .backpanel {
        width: 27.3mm;
        height: 37mm;
        border-radius: 1mm;
        overflow: hidden;
    }
    .card .content-right .qrcode-bg {
        position: absolute;
        right: 1.4mm;
        top: 1.5mm;
        width: 24.5mm;
        height: 24.5mm;
    }
    .card .content-right .frontpanel {
        position: absolute;
        right: 1.4mm;
        top: 1.5mm;
        width: 24.5mm;
    }
    .card .content-right .frontpanel .qrcode {
        display: block;
        width: 21.8mm;
        height: 21.8mm;
        padding: 1.4mm 1.2mm;
    }
    .card .content-right .frontpanel .desc {
        width: 20.5mm;
        margin: .3mm auto;
        font: 300 3.6mm/4.9mm "Open Sans";
        text-align: center;
        color: #fff;
    }
    @media print {
        .card .title,
        .card .content-right .frontpanel .desc,
        .card .content-left .desc,
        .card .content-left .footer {
            color: rgba(0, 0, 0, 0);
        }
        .card .title,
        .card .content-right .frontpanel .desc {
            text-shadow: 0 0 0 #fff;
        }
        .card .content-left .desc,
        .card .content-left .footer {
            text-shadow: 0 0 0 #424C51;
        }
        @media print and (-webkit-min-device-pixel-ratio:0) {
            .card .title,
            .card .content-right .frontpanel .desc,
            .card .content-left .desc,
            .card .content-left .footer {
                -webkit-print-color-adjust: exact;
            }
            .card .title,
            .card .content-right .frontpanel .desc {
                color: #fff;
            }
            .card .content-left .desc,
            .card .content-left .footer {
                color: #424C51;
            }
        }
    }
  </style>
  `
];

const HEADER_LINKS = [
  {
    rel: "stylesheet",
    crossorigin: "anonymous",
    href: "https://fonts.googleapis.com/css?family=Roboto:300,700",
  },
  {
    rel: "stylesheet",
    crossorigin: "anonymous",
    href: "https://fonts.googleapis.com/css?family=Open+Sans:300,700",
  }
];

const cardTemplate = (building, QR_Src) => {
  return `
            <div class="col">
                <div class="col-inner">
                    <div class="card">
                        <div class="title"><div class="icon"><svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="exclamation-triangle" class="svg-inline--fa fa-exclamation-triangle fa-w-18" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path fill="currentColor" d="M569.517 440.013C587.975 472.007 564.806 512 527.94 512H48.054c-36.937 0-59.999-40.055-41.577-71.987L246.423 23.985c18.467-32.009 64.72-31.951 83.154 0l239.94 416.028zM288 354c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46zm-43.673-165.346l7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654z"></path></svg></div> Important</div>
                        <div class="content">
                            <div class="content-inner">
                                <div class="content-left">
                                    <div class="slogan">Emergency Lights Test Automatically</div>
                                    <div class="desc">${building.name}</div>
                                    <div class="desc">${!building.strata_no || building.strata_no === building.name ? '' : building.strata_no}</div>
                                    <div class="footer"><img class="logo" src="/images/logo.png"> Networked emergency lighting system</div>
                                </div>
                                <div class="content-right">
                                    <div class="backpanel"><svg width="100%" height="100%"><rect width="100%" height="100%" style="fill:#424C51" /></svg></div>
                                    <div class="qrcode-bg"><svg width="100%" height="100%"><rect width="100%" height="100%" style="fill:#FFFFFF" /></svg></div>
                                    <div class="frontpanel">
                                        <img class="qrcode" src="${QR_Src}"/>
                                        <div class="desc">Download Test Report</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    `;
};

const rowTemplate = (card) => {
  return `
    <div class="row">
        <div class="row-title"><svg width="100%" height="100%"><rect width="100%" height="100%" style="fill:#EE3128" /></svg></div>
        ${card}
        ${card}
    </div>
    `;
};

const bodyTemplate = (content) => {
  return `<body>${content}</body>`;
};

const fontLoadCheckTemplate = () => `
  window.onload = function() {
    if (window.document.fonts !== undefined && window.document.fonts.ready !== undefined) {
      document.fonts.ready.then(function () {
        window.print();
      });
    }
    else {
      window.print();
    }     
  }
`;

export default class QRCode {

  /**
   * constructor
   *
   * @param {object} el , DOM object
   * @param {object} building
   * @param {string} QR_Src
   */
  constructor(el, building, QR_Src) {
    this.el = el;
    this.building = building;
    this.QR_Src = QR_Src;
  }

  loadBody() {
    let content = CSS.join("");
    let card = cardTemplate(this.building, this.QR_Src);
    for (let i = 0; i < 5; i++) {
      content += rowTemplate(card);
    }

    this.el.contentWindow.document.write(bodyTemplate(content));
  }

  loadHead() {
    for (let i = 0; i < HEADER_LINKS.length; i++) {
      let link = window.document.createElement("link");
      Object.assign(link, HEADER_LINKS[i]);
      this.el.contentWindow.document.head.appendChild(link);
    }
  }

  loadPrintTrigger() {
    let script = window.document.createElement("script");
    script.type = "text/javascript";
    script.appendChild(window.document.createTextNode(fontLoadCheckTemplate()));
    this.el.contentWindow.document.head.appendChild(script);
  }
}